// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1oWbJ","savePackageButton":"ClientWallet_savePackageButton__trbfc"};